// extracted by mini-css-extract-plugin
export default {"animated":"_2jAtyaoL","modal":"_2Z7GucWm scrollable-y","fullscreen":"_1RYkmETY","overlay":"_39UrM6pf"};